import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import InterventionReportBloc from "../InterventionReportBloc";
import { guid } from "../../../utils";
import { blocsAreDifferents, setExpandedBloc } from "../../../redux/intervention/interventionActions";
import AddBlocModal from "../../Blocs/AddBlocModal";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { SIGNATURES_BLOC_TYPE_CODE } from "../../../redux/intervention/interventionConstants";

const styles = {
    root: {
        width: "100%",
        marginTop: "5px",
    },
};

class VariableTab extends Component {
    constructor(props) {
        super(props);
        let blocTypes = props.blocTypes.filter((bt) => bt.category_id.id === props.category.id);

        if (this.props.signature) {
            blocTypes = blocTypes.filter((bt) => bt.code === SIGNATURES_BLOC_TYPE_CODE);
        }

        this.state = {
            blocs: this.props.blocs,
            blocTypes,
            alreadyAdding: false,
        };
    }

    handleChange = (blocId) => {
        let collapsing = blocId === this.props.expandedBloc;

        this.props.setExpandedBloc(collapsing ? null : blocId);
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        let blocs = nextProps.blocs.filter((b) => prevState.blocTypes.find((bt) => bt.id === b.type_id));
        return { blocs };
    }

    shouldComponentUpdate(nextProps, nextState) {
        let modalStatusChange = this.state.alreadyAdding !== nextState.alreadyAdding;
        let stateChange = this.props.intervention.state !== nextProps.intervention.state;
        let expandedChange = this.props.expanded !== nextProps.expanded;
        let selectedTabChange = this.props.selectedTab !== nextProps.selectedTab;

        let blocsNumberChange =
            nextState.blocs.filter((b) => !b.deleted).length !== this.state.blocs.filter((b) => !b.deleted).length;

        return (
            selectedTabChange ||
            expandedChange ||
            stateChange ||
            modalStatusChange ||
            blocsNumberChange ||
            blocsAreDifferents(nextState.blocs, this.state.blocs)
        );
    }

    addBloc(blocType) {
        let blocTypes = this.state.blocTypes.filter((bt) => bt.published);

        if (blocTypes.length <= 0) {
            this.props.throwErrorMessage({
                title: "Erreur",
                message: "Impossible d'ajouter un bloc dans cette catégorie",
            });

            return;
        }

        if (blocTypes.length === 1) blocType = blocTypes[0];

        if (!blocType) {
            this.setState({
                alreadyAdding: true,
            });

            return;
        }

        let blocs = [...this.state.blocs.filter((b) => !b.deleted)];
        let newBloc = {
            id: guid(),
        };

        blocs.push(newBloc);
        this.props.addOrRemoveBloc(blocType.id, newBloc.id, true);

        this.setState({
            blocs,
        });

        this.props.setExpandedBloc(newBloc.id);

        this.closeModal();
    }

    closeModal() {
        this.setState({ alreadyAdding: false });
    }

    deleteBloc(blocId) {
        let confirmation = window.confirm("Êtes-vous sûr(e) de vouloir supprimer ce bloc?");

        if (!confirmation) return;

        let blocs = [...this.state.blocs.filter((b) => !b.deleted)];

        let bloc = blocs.find((b) => b.mobile_id === blocId);

        if (!bloc) {
            console.error("Bloc introuvable");
            return;
        }

        let blocType = this.state.blocTypes.find((bt) => bt.id === bloc.type_id);

        bloc.deleted = true;

        this.setState({
            blocs,
        });

        this.forceUpdate();
        this.props.addOrRemoveBloc(blocType.id, bloc.mobile_id, false);
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        if (!this.props.selectedTab && !this.props.preview && !this.props.controlSignature) return null;

        let blocElements = [];
        this.state.blocs.forEach((b) => {
            if (b.deleted) return;

            let blocType = this.state.blocTypes.find((bt) => bt.id === b.type_id);

            if (!blocType) {
                console.error("Le type de bloc est introuvable");
                return;
            }

            let blocIndex = b.id || b.mobile_id;

            blocElements.push(
                <InterventionReportBloc
                    key={blocIndex}
                    id={"bloc-" + b.type_id + "-" + blocIndex}
                    currentBlocId={b.mobile_id}
                    deleteBloc={this.deleteBloc.bind(this)}
                    blocType={blocType}
                    onClick={this.handleChange.bind(this)}
                    fieldValueChange={this.props.fieldValueChange.bind(this)}
                    validated={b.validated}
                    signed_by_customer={b.signed_by_customer}
                />
            );
        });

        let creationIndex = -1;

        if (
            this.props.intervention.state === "performed" &&
            !this.props.preview &&
            !this.props.controlSignature &&
            this.state.blocTypes.filter((bt) => bt.published).length > 0
        ) {
            blocElements.push(
                <InterventionReportBloc
                    key={creationIndex}
                    id={"bloc-creation-" + creationIndex}
                    addBloc={this.addBloc.bind(this)}
                    creationBloc
                />
            );
        }

        return (
            <div className={classes.root}>
                <AddBlocModal
                    opened={this.state.alreadyAdding}
                    addBloc={this.addBloc.bind(this)}
                    closeModal={this.closeModal.bind(this)}
                    options={this.state.blocTypes.filter((bt) => bt.published)}
                />
                {blocElements.map((be) => be)}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        blocs: state.intervention.blocs,
        preview: state.intervention.preview,
        controlSignature: state.intervention.controlSignature,
        intervention: state.intervention.currentIntervention,
        expandedBloc: state.intervention.expandedBloc,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setExpandedBloc: (blocId) => dispatch(setExpandedBloc(blocId)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(VariableTab);
